module.exports = __webpack_public_path__ + "img/118D-1.ccc87878.png";